/* 808 Sound Lab · JS global ligero (drain). Sin dependencias. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Aparición al hacer scroll para elementos con [data-d-reveal]
  const io = 'IntersectionObserver' in window && !reduce.matches
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 })
    : null;

  const scan = (root = document) => {
    root.querySelectorAll('[data-d-reveal]:not(.is-in)').forEach((el) => {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  };
  document.addEventListener('DOMContentLoaded', () => scan());
  // El personalizador recarga secciones sueltas: volver a escanear
  document.addEventListener('shopify:section:load', (e) => scan(e.target));

  // Un solo audio sonando a la vez en toda la web
  document.addEventListener('play', (e) => {
    if (!(e.target instanceof HTMLAudioElement)) return;
    document.querySelectorAll('audio').forEach((a) => { if (a !== e.target) a.pause(); });
  }, true);
})();
